// extracted by mini-css-extract-plugin
export default {"ComponentBox":"SearchedInterestComponent_ComponentBox__y+l9z","componentBoxText":"SearchedInterestComponent_componentBoxText__T5EOV","icon":"SearchedInterestComponent_icon__cIgYC"};